"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariantLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./VariantLink.scss");
var VariantLink = function VariantLink(_ref) {
  var className = _ref.className,
    label = _ref.label,
    onProductClick = _ref.onProductClick,
    thumbnail = _ref.thumbnail,
    url = _ref.url,
    sku = _ref.sku;
  var rootClassName = (0, _classnames["default"])('cds-ProductBox-VariantLink', {
    'cds-ProductBox-VariantLink--Title': !thumbnail
  }, className);
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: rootClassName,
    href: url,
    onClick: onProductClick(sku),
    title: label
  }, thumbnail && /*#__PURE__*/_react["default"].createElement("img", {
    alt: label,
    className: "cds-ProductBox-VariantImage",
    src: thumbnail
  }), !thumbnail && label);
};
exports.VariantLink = VariantLink;